<template>
<div class="main">
   <header class="centerH2">
    <a @click="()=>$router.push({name:'Accout'})" class="btn-back">
        <img src="@/assets/img/i-left-grey.png" alt="">
    </a>
    读者证绑定
</header>
<div class="main bindM">
    <div class="inner">
        <p class="tit">绑定的读者证</p>
        <div class="iptBox">
            <input type="text" v-model="serialId" placeholder="在此输入读者证" class="mipt">
            <button type="button"  class="mclear" ></button>
        </div>
        <a @click="handleSubmit" :class="{'btn_bind':true,'disabled':disable}">
            绑定
        </a>
        <!-- <a href="##" class="btn_edit">
            修改
        </a> -->
    </div>
</div>
    <div class="modal-item modal-toplimit" :style="{display:(toplimit?'block':'none')}">
        <p>
            {{toast}}
        </p>
        <div class="opts">
            <a @click="()=>toplimit=false" class=" btn-sure">
                知道了
            </a>
        </div>
    </div>
</div>
</template>
<script>
import { updateSerialId, getSerialId } from "@/api/user";
export default {
  data() {
    return {
      serialId: "",
      disable: true,
      toplimit: false,
      toast: "",
    };
  },
  watch: {
    serialId(newValue, OldValue) {
      if (newValue == null || newValue.length == 0) {
        this.disable = true;
      } else {
        this.disable = false;
      }
    },
  },
  methods: {
    handleSerial() {
      getSerialId().then((res) => {
        if (res.data.serialId == null) {
          this.serialId = "";
        } else {
          this.serialId = res.data.serialId;
        }
      });
    },
    handleSubmit() {
      if (!this.disable) {
        updateSerialId(this.serialId)
          .then((res) => {
            this.toplimit = true;
            this.toast = "读者证修改成功";
          })
          .catch((error) => {
            this.toplimit = true;
            this.toast = "读者证修改失败";
          });
      }
    },
  },
  mounted() {
    var deviceWidth;
    setHtmlFontSize();

    if (window.addEventListener) {
      window.addEventListener(
        "resize",
        function() {
          setHtmlFontSize();
        },
        false
      );
    }
    function setHtmlFontSize() {
      // 1920设计稿宽度
      deviceWidth =
        document.documentElement.clientWidth > 750
          ? 750
          : document.documentElement.clientWidth;
      document.getElementsByTagName("html")[0].style.cssText =
        "font-size:" + deviceWidth / 7.5 + "px !important";
    }
    this.handleSerial();
  },
};
</script>
<style scoped>
@import "~@/assets/css/center.css";
</style>
